module.exports = __webpack_public_path__ + "img/NA-Caribbean-broadside.4b6faa8e.png";